// src/routes/candidateRoutes.tsx
import { Suspense } from 'react';
import { Route } from 'react-router-dom';
import ProtectedRoute from '../auth/ProtectedRoute';
import Loader from '../components/Loader';
import candidateRoutesConfig from './config/candidateRoutesConfig';

const CandidateRoutes = candidateRoutesConfig.map(({ path, component: Component }) => (
  <Route
    key={path}
    path={path}
    element={
      <Suspense fallback={<Loader />}>
        <ProtectedRoute element={<Component />} allowedRoles={['Candidate', 'Admin', 'HR']} />
      </Suspense>
    }
  />
));

export default CandidateRoutes;
